<template>
  <div class="content-container">
    <!-- <div class="top-control-container">
      <div class="navigator">
        <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
      </div>
    </div> -->
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <!-- <div class="das-form-col col-8">
            <div class="das-form-input">
              <div class="checkbox-wrap">
                <input
                  id="includeNoActive"
                  v-model="searchParams.includeNoActive"
                  type="checkbox"
                  @change="attachData"
                />
                <label for="includeNoActive">
                  {{ $t('field.showInactiveRoomServiceGroup') }}
                </label>
              </div>
            </div>
          </div> -->
          <div class="das-form-col col-4">
            <div class="das-form-input">
              <div class="label">{{ $t('field.showRoomServiceGroup') }}</div>
              <el-select
                v-model="searchParams.active"
                placeholder=""
                @change="attachData"
              >
                <el-option
                  v-for="item in roomServiceActiveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-loading="roomServGroupGridLoading" class="grid-scroll">
      <GridVx
        ref="roomServiceGroupGrid"
        row-selection="single"
        :columns="roomServGroupCols"
        :rows="roomServGroupRows"
        :auto-size-cell="true"
        class="agGrid"
        @selectionChanged="onSelectRoomSerGroup"
      />
    </div>
    <!-- <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div> -->
    <el-col class="bottom-btns-container">
      <div class="button-containers mb-0">
        <button
          class="btn primary small outline"
          @click="deleteRoomServiceGroup"
        >
          {{ $t('button.deleteGroup') }}
        </button>

        <button class="btn primary small" @click="openEditDialog">
          {{ $t('button.modifyGroup') }}
        </button>
        <button class="btn primary small" @click="openAddDialog">
          {{ $t('button.addGroup') }}
        </button>
        <button class="btn primary small" @click="openAttachServiceDialog">
          {{ $t('button.attachService') }}
        </button>
      </div>
      <!-- <el-button type="primary" @click="dialogFormVisible = true">
        Thêm toà nhà
      </el-button>
      <el-button type="danger" @click="deleteBuilding">
        Xóa tòa nhà
      </el-button> -->
    </el-col>

    <RoomServiceGroupFormDialog
      :is-show="dialogFormVisible"
      :is-edit-dialog="isEditDialog"
      :room-service-group="selectedRoomServGroup"
      @close="fnCloseFormDialog"
      @refreshData="attachData"
    />
    <AttachServiceDialog
      :is-show="dialogAttachServiceVisible"
      :room-service-group-id="selectedRoomServGroup?.id"
      @close="fnCloseAttachServiceDialog"
    />
  </div>
</template>

<script>
/* eslint-disable */
import {
  getRoomServiceGroupApi,
  deleteRoomServiceGroupApi
} from '@/api/Service_Policy/roomServiceGroup'

import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import RoomServiceGroupFormDialog from './components/RoomServiceGroupFormDialog.vue'
import AttachServiceDialog from './components/AttachServiceDialog.vue'

import { Message } from 'element-ui'
export default {
  components: {
    CellRenderCheckboxReadonly,
    RoomServiceGroupFormDialog,
    AttachServiceDialog
  },
  data() {
    return {
      isEditDialog: false,
      dialogFormVisible: false,
      dialogAttachServiceVisible: false,
      searchParams: {
        // includeNoActive: false,
        active: null
      },

      roomServGroupGridLoading: false,
      roomServGroupCols: [
        {
          headerName: this.$t('grid.column.groupCode'),
          field: 'code',
          tooltipField: 'code',
          minWidth: 150,
          sortable: false

          // cellClass: 'grid-cell-centered',
        },
        {
          headerName: this.$t('grid.column.groupName'),
          field: 'name',
          tooltipField: 'name',
          minWidth: 150,
          sortable: false

          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.transaction'),
          field: 'transaction',
          minWidth: 200,
          tooltipField: 'transaction',
          sortable: false

          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.defaultTransactionPage'),
          field: 'default_transaction_page_name',
          tooltipField: 'default_transaction_page_name',
          minWidth: 200,
          sortable: false

          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.includeTaxFee'),
          field: 'tax_fee',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          minWidth: 150,
          maxWidth: 150,
          sortable: false

          // cellClass: 'grid-cell-centered'
        },
        {
          headerName: this.$t('grid.column.active'),
          field: 'active',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          minWidth: 100,
          maxWidth: 100,
          sortable: false

          // cellClass: 'grid-cell-centered'
        }
      ],
      roomServGroupRows: [],
      roomServiceActiveOptions: [
        {
          value: null,
          label: this.$t('variables.all')
        },
        {
          value: '10',
          label: this.$t('variables.active')
        },
        {
          value: '20',
          label: this.$t('variables.nonActive')
        }
      ],
      selectedRoomServGroup: null
    }
  },
  mounted() {
    this.attachData()

    // GRID
    this.roomServiceGroupGridApi = this.$refs.roomServiceGroupGrid.gridApi
  },
  methods: {
    // onRefresh(data) {
    //   let params = {
    //     orderBy: data.orderBy,
    //     orderTp: data.sort
    //   }
    //   this.searchParams = { ...this.searchParams, ...params }
    //   this.attachData()
    // },
    // async onPageChanged(pageNum) {
    //   this.searchParams.pageNum = pageNum
    //   await this.attachData()
    // },
    // async onPageSizeChange(pageSize) {
    //   this.searchParams.pageSize = pageSize
    //   this.searchParams.pageNum = 1
    //   await this.attachData()
    // },
    async attachData() {
      this.roomServGroupGridLoading = true

      // const params = {
      //   active: this.searchParams.includeNoActive ? null : 10
      // }

      await getRoomServiceGroupApi(this.searchParams).then(res => {
        this.roomServGroupRows = res.data
      })
      this.roomServGroupGridLoading = false
    },
    //   ('on Double Click', rows)
    //   this.titlePopup = 'Sửa toà nhà'
    //   this.isEditDialog = true
    //   const rowData = rows[0]
    //   this.buildingItem.building_no = rowData.building_no
    //   this.buildingItem.name = rowData.name
    //   this.buildingItem.id = rowData.id
    //   this.dialogFormVisible = true
    // },

    onSelectRoomSerGroup(rows) {
      this.selectedRoomServGroup = rows?.[0]
    },

    // DIALOGS
    openAddDialog() {
      this.isEditDialog = false
      this.dialogFormVisible = true
    },
    openEditDialog() {
      if (this.selectedRoomServGroup) {
        this.isEditDialog = true
        this.dialogFormVisible = true
      } else {
        this.$message({
          message: this.$t('errorMsg.selectRoomServiceGroup'),
          type: 'error'
        })
      }
    },
    deleteRoomServiceGroup() {
      const rowsSelected = this.roomServiceGroupGridApi.getSelectedRows()
      if (rowsSelected?.length) {
        this.$vxConfirm(this.$t('alert.deleteRoomServiceGroup'), () => {
          let id_list = rowsSelected.map(item => item.id)
          deleteRoomServiceGroupApi({ id_list })
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('successMsg.' + res.message)
              })
              this.attachData()
            })
            .catch(err => {
              this.$message({
                type: 'error',
                message: this.$t('errorMsg.' + err.response.data.message)
              })
            })
        })
      } else {
        this.$message({
          message: this.$t('errorMsg.selectRoomServiceGroup'),
          type: 'error'
        })
      }
    },
    fnCloseFormDialog() {
      this.dialogFormVisible = false
    },
    openAttachServiceDialog() {
      if (this.selectedRoomServGroup) {
        this.dialogAttachServiceVisible = true
      } else {
        this.$message({
          message: this.$t('errorMsg.selectRoomServiceGroup'),
          type: 'error'
        })
      }
    },
    fnCloseAttachServiceDialog() {
      this.dialogAttachServiceVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
